module.exports = __webpack_public_path__ + "img/title_logo_en.1ac0d336.svg";